import { ArcGraph } from '../../../layouts/general/arcGraph.js';
import { primaryColor } from '../../../layouts/general/general';

var htmlArcs = document.getElementsByClassName('mcl-arc-number');

Array.prototype.forEach.call(htmlArcs, (arc) => {

    const perc = arc.getAttribute('is-percent') ? arc.getAttribute('percentage') : 100;
    const id = arc.id;

    var graph = new ArcGraph(122,0);
    graph.addArc({padding: 0, stroke: 'currentColor', strokeWidth: 2, percentage: perc});
    graph.appendTo('#' + id);

});




// WEBPACK FOOTER //
// ./src/components/molecules/arc-number/arc-number.js